import React from "react"
import "./nav.scss"
import Link from "gatsby-link"
import logo from "../images/logo.svg"
import instagram from "../images/instagram.svg"
import facebook from "../images/facebook.svg"
import youtube from "../images/youtube.svg"

const nav = () => {
  return (
    <div className="nav__menu">
      <div className="logo__container">
        <Link to="/">
          <img src={logo} className="logo" alt="Daisy Godfrey Logo" />
        </Link>
      </div>
      <Link to="/" activeClassName="active" className="nav__menu__item">
        Home
      </Link>
      <Link to="/contact" activeClassName="active" className="nav__menu__item">
        Contact
      </Link>
      <a
        href="https://www.facebook.com/daisygodfreymusic/"
        className="nav__menu__social"
      >
        <img src={facebook} className="logo" alt="facebook" />
      </a>
      <a
        href="https://www.instagram.com/daisygodfreymusic/"
        className="nav__menu__social"
      >
        <img src={instagram} className="logo" alt="instagram" />
      </a>
      <a
        href="https://www.youtube.com/channel/UCIbuk8k8GQyiMUyKpxjmAxQ"
        className="nav__menu__social"
      >
        <img src={youtube} className="logo" alt="youtube" />
      </a>
    </div>
  )
}

export default nav
